import { useEffect, useRef, useState } from "react";
import { ReactComponent as ChevronUp } from "assets/chevron-up.svg";

interface ScrollToTopButtonProps {
  threshold?: number;
}

export const ScrollToTopButton = ({ threshold = 300 }: ScrollToTopButtonProps) => {
  const [isVisible, setIsVisible] = useState(false);
  const scrollTargetRef = useRef<Element | null>(null);

  useEffect(() => {
    const handleScroll = (e: Event) => {
      const target = e.target as Element;
      if (target.scrollTop > threshold) {
        scrollTargetRef.current = target;
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    document.addEventListener("scroll", handleScroll, true);
    return () => document.removeEventListener("scroll", handleScroll, true);
  }, [threshold]);

  if (!isVisible) return null;

  return (
    <button
      type="button"
      onClick={() =>
        scrollTargetRef.current?.scrollTo({ top: 0, behavior: "smooth" })
      }
      className="flex fixed right-6 bottom-6 z-20 justify-center items-center w-12 h-12 text-white bg-primary-600 hover:bg-primary-800 rounded-full shadow-lg"
      aria-label="Scroll to top"
    >
      <ChevronUp className="w-6 h-6 fill-white" aria-hidden />
    </button>
  );
};
